<!--QR Code-->
<div>
	<div class="QRBorder">
		<img class="IMG" [src]="QRCodeB64" />
	</div>

	<div class="TextGrid">
		<label>Plain Text:</label>
		<textarea class="TextArea" [(ngModel)]="PlainText" disabled></textarea>

		<label>Encrypted:</label>
		<textarea class="TextArea" [(ngModel)]="EncryptedText" disabled></textarea>
	</div>
</div>

<!--Options-->
<div class="MainGrid2Col">
	<label>Person ID</label>
	<input [disabled]="IsLoading()" class="form-control" type="text" [(ngModel)]="PersonID" />

	<label>Expire Date</label>
	<p-calendar [disabled]="IsLoading()" [(ngModel)]="ExpireDate" showIcon="true" showButtonBar="true"></p-calendar>

	<label>URL:</label>
	<input [disabled]="IsLoading()" class="form-control" type="text" [(ngModel)]="URL" />
</div>

<!--Debug Decrypt-->
<div class="MainGrid2Col TopMargin">
	<label>Text to Decrypt</label>
	<textarea class="TextArea" [(ngModel)]="TextToDecrypt"></textarea>

	<label>Decrypted Text</label>
	<textarea class="TextArea" [(ngModel)]="DecryptedText" disabled></textarea>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading()" class="btn btn-success" (click)="onRefresh()">Refresh</button>
	<button class="btn btn-warning LeftMargin" (click)="onClose()">Close</button>
</div>
